import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import type {BrandKitPaletteEditorProps} from '@Components/auto-branding/components/brand-kit-palette-editor';
import {BrandKitPaletteEditor} from '@Components/auto-branding/components/brand-kit-palette-editor';

window.PMW.mergePMW(PMW, {
  /**
   * @param {HTMLElement} containerElement
   * @param {object} opts
   * @param {ColorPaletteInfo} [opts.brandKitPalette]
   * @param {ColorPaletteInfo} [opts.appliedPalette]
   * @param {ColorPaletteInfo[]} [opts.suggestedPalettes]
   * @param {string} [opts.buttonCtaText]
   * @param {Type} [opts.buttonType]
   * @param {function} [opts.onPaletteSelect]
   * @param {function} [opts.onBrandKitUpdate]
   * @param {string} [opts.colorPaletteAppliedEvent]
   */
  renderBrandKitPaletteEditor(containerElement: HTMLElement, opts: BrandKitPaletteEditorProps) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <BrandKitPaletteEditor {...opts} />
      </Provider>
    );
  },
});
